import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isDaily } from "@madmedical/medical";
import { useMemo } from "react";
import { formatTime } from "@madmedical/utils";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import ReactTable from "../molecules/ReactTable";
import ActionButton from "../molecules/ActionButton";
import Badge from "../atoms/Badge";
import StatusBadge from "../atoms/StatusBadge";
const MeasurementsTable = ({ data, onEndReached, onDeletePress, metricType, isPatient = true, }) => {
    const { t } = useTranslation();
    let columns = useMemo(() => [
        {
            Header: t("appointment"),
            accessor: "measuredAt",
            width: "30%",
            Cell: ({ row: { original: measurement } }) => (_jsxs(_Fragment, { children: [formatTime(measurement.measuredAt), measurement.manual && !measurement.deleted && (_jsx(Badge, Object.assign({ variant: "base", ml: 2, hasIndicator: false }, { children: t("measures:manual") }))), measurement.deleted && (_jsx(Badge, Object.assign({ variant: "base", ml: 2, hasIndicator: false }, { children: t("measures:deleted") })))] })),
        },
        {
            Header: t("value"),
            accessor: "displayValue",
            width: "auto",
        },
        {
            Header: t("measures:alert"),
            accessor: "alertLevel",
            width: "30%",
            Cell: ({ value: alertLevel }) => (_jsx(StatusBadge, { level: alertLevel })),
        },
        {
            Header: "",
            id: "action",
            width: 40,
            Cell: ({ row: { original: measurement } }) => (_jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-end", w: "full" }, { children: _jsx(ActionButton, { size: "xs", actions: measurement.manual && !measurement.deleted
                        ? [
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress(measurement.id);
                                },
                            },
                        ]
                        : [] }) }))),
        },
    ], [onDeletePress, t]);
    if (!isPatient) {
        columns = columns.filter((column) => column.id !== "action");
    }
    if (isDaily(metricType)) {
        columns.shift();
    }
    return (_jsx(ReactTable, { columns: columns, data: data, onEndReached: onEndReached }));
};
export default MeasurementsTable;
